import {
	GetForeignApplicantDetailResponse,
	GetForeignApplicantListResponse,
	GetWorkerApplicantProgramListResponse,
} from '@/services';

import { convertFilePath, formatDate, map } from 'utils';

export const formatForeignApplicantDetail = (
	input: GetForeignApplicantDetailResponse
) => {
	return {
		...input,
		registDt: formatDate(input.registDt),
		updateDt: formatDate(input.updateDt),
		avatarFile:
			convertFilePath(input?.avatarFile || input?.avatar?.[0]?.path) || '',
		avatarId: input?.avatarId || input?.avatar?.[0]?.id,
	};
};

export const formatForeignApplicantListItem = (
	input: GetForeignApplicantListResponse['content'][number]
) => {
	return {
		...input,
		id: input?.foreignApplicantId,
		foreignApplicantBirthDate: formatDate(input?.foreignApplicantBirthDate),
		foreignApplicantPassportIssueDate:
			formatDate(input?.foreignApplicantPassportIssueDate) || null,
		foreignApplicantPassportExpireDate:
			formatDate(input?.foreignApplicantPassportExpireDate) || null,
		foreignApplicantRegistDt: formatDate(input?.foreignApplicantRegistDt),
		foreignApplicantUpdateDt: formatDate(input?.foreignApplicantUpdateDt),
		foreignApplicantHeight: input?.foreignApplicantHeight || '',
	};
};

export const formatForeignApplicantList = (
	input: GetForeignApplicantListResponse['content']
) => {
	return map(input, formatForeignApplicantListItem);
};

export const formatForeignApplicantProgramDetail = (
	data: GetWorkerApplicantProgramListResponse['content'][number]
) => {
	return {
		...data,
		startDate: formatDate(data?.startDate),
		endDate: formatDate(data?.endDate),
		registDt: formatDate(data?.registDt),
	};
};

export const formatForeignApplicantProgramList = (
	input: GetWorkerApplicantProgramListResponse['content']
) => {
	return map(input, formatForeignApplicantProgramDetail);
};
